import {createEnvironmentApi, Environment} from "./environment.schema";

const coreHost = "https://internal.api.staging.qundo.de";
const aiHost = "https://internal.api.staging.qundo.de/ai-wrapper";
const envTile = "<b style='color:red;'> (STAGING: qundo.de)</b>";

export const environment: Environment = {
    api: createEnvironmentApi(coreHost, aiHost),
    envTile: envTile,
    client: {
        clientName: "admin_client",
        clientSecret: "client_password"
    },
    production: true
};
